import { Button } from 'component/Button'
import { Select } from 'component/Select'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Pages } from 'page/catalog/Pagination/Pages'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './PaginationBottom.module.scss'

export const PaginationBottom = observer(() => {
  const demo = useDemo()
  const { limit, limits, canMore, busy } = demo.form
  const options = limits.map((n) => ({ value: n.toFixed() }))

  const onMore = useLatestCallback(async () => {
    demo.form.more()
    setTimeout(() => window.scrollTo({ top: 1e9, behavior: 'smooth' }), 10)
  })

  const onLimit = useLatestCallback((value: string) => {
    demo.form.limit = parseInt(value)
  })

  return (
    <Space className={css.root} opposite wrap>
      <Pages />

      <Space>
        {canMore && (
          <Button
            className={css.more}
            large
            invert
            disabled={busy}
            action={onMore}
          >
            {i18n('demo.ShowMore')}
          </Button>
        )}
      </Space>

      {demo.form.count > limits[0] && (
        <Space gap={8} flex="1" right>
          <Typo size={11} medium upper secondary>
            {i18n('ShowOnPage')}
          </Typo>
          <Select
            value={limit.toFixed()}
            options={options}
            onChange={onLimit}
          />
        </Space>
      )}
    </Space>
  )
})
